define('StockInformation.EntryPoint',
	[
		'StockInformation.View',
		'StockInformation.Model',
		'Facets.ItemCell.View',
		'Facets.Browse.View',
		'jQuery',
		'underscore'
	]
	, function (
		StockInformationView,
		StockInformationModel,
		FacetsItemCellView,
		FacetsBrowseView,
		jQuery,
		_
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var pdpComponent = container.getComponent('PDP');
				var plpComponent = container.getComponent('PLP');
				var environmentComponent = container.getComponent('Environment');

				if (pdpComponent) {
					pdpComponent.addChildView('Product.Price', function () {
						return new StockInformationView({
							container: container,
							itemInfo: pdpComponent.getItemInfo()
						});
					});
				}

				if (plpComponent && environmentComponent) {
					var self = this;
					self.stockInformation = environmentComponent.getConfig('StockInformation');

					_.extend(FacetsItemCellView.prototype, {

						getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (fn, e) {
							var ret = fn.apply(this, _.toArray(arguments).slice(1));

							if (ret && ret.quantityAvailableInformation) {
								var quantityInformation = ret.quantityAvailableInformation[0];
								var itemQuantity = quantityInformation? quantityInformation.availableQuantity : 0;
								if (itemQuantity == self.stockInformation['outOfStockQuantity']) {
									self.stockMessage = self.stockInformation['outOfStock'];
									self.stockMessageIdentifier = 'outOfStock';
								} else if (itemQuantity > self.stockInformation['outOfStockQuantity'] && itemQuantity < self.stockInformation['inStockQuantity']) {
									self.stockMessage = itemQuantity + ' ' + self.stockInformation['lowStock'];
									self.stockMessageIdentifier = 'lowStock';
								} else {
									self.stockMessage = self.stockInformation['inStock'];
									self.stockMessageIdentifier = 'inStock';
								}
								ret.stockMessage = self.stockMessage,
									ret.stockMessageIdentifier = self.stockMessageIdentifier
							}
							return ret;
						})
					});
				}
			}
		};
	});
